import { ActivityEventKind } from "./types";
import type { ActivityEventProvider } from "./types";
import { asyncTaskProvider } from "./asyncTaskProvider";
import { ciModelChangeProvider } from "./ciModelChangeProvider";

/**
 * Maps activity event kind (Firestore value) → provider implementation.
 *
 * To support a new kind of activity event:
 * 1. Create a provider file in this directory (e.g. modelTrainingProvider.ts)
 * 2. Register it here keyed by its ActivityEventKind value
 */
export const providerRegistry: Partial<Record<ActivityEventKind, ActivityEventProvider>> = {
    [ActivityEventKind.AsyncTask]: asyncTaskProvider,
    [ActivityEventKind.CIModelChange]: ciModelChangeProvider
};
